import { NavigationTabContainer } from '@/components/common';
import { ControlsPalette } from '@/controls/components/action-menu/controls-palette';
import { BackButton } from '@/widgets/components/back-button';
import { PropertyDetailsTabs } from './property-details-tabs';

export function HeaderContainer() {
  return (
    <div>
      <NavigationTabContainer>
        <BackButton />
        <ControlsPalette />
      </NavigationTabContainer>

      <PropertyDetailsTabs />
    </div>
  );
}
